mobileSize = 1000;

$(document).ready(function(){
  // General Message
  $('.generalmessage').prependTo('header');

  // Header Buttons
  if ($('body').hasClass('saffireMobileSize')) {
    $('#headerButtons').prependTo('.content');
  } else {
    $('#headerButtons').insertBefore('.mobile-nav-toggle');
  }

  // countdown wrapper
  if ($('body').hasClass('saffireMobileSize')) {
    $('.countdown-wrapper').prependTo('.content .tier-one');
  } else {
    $('.countdown-wrapper').insertBefore('.header-top');
  }

  // Replace Saffire Logo
	$('.saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire.png');

  // Custom Email Signup (Footer)
  $('.footer .emailSignup .emailSignupText').text('Sign Up for the Latest Updates');
  $('.footer .emailSignup .emailSubmitButton').text('Subscribe');
  $('.footer .emailSignup .emailInputField input')
    .attr('value', '')
    .attr('placeholder', 'Email Address')
    .attr('onclick', 'ClearDefaultText(this, "Email Address")');
});

$(window).resize(function() {
  // Header Buttons
  if ($('body').hasClass('saffireMobileSize')) {
    $('#headerButtons').prependTo('.content');
  } else {
    $('#headerButtons').insertBefore('.mobile-nav-toggle');
  }

  // countdown wrapper
  if ($('body').hasClass('saffireMobileSize')) {
    $('.countdown-wrapper').prependTo('.content .tier-one');
  } else {
    $('.countdown-wrapper').insertBefore('.header-top');
  }
});